export default __webpack_public_path__ + "static/media/DSCN2327.cd45b09e.JPG";